import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSimplrAccountIdOfSelectedTicket } from '../../../../extractFromState';
import { getAccounts } from '../../../../selectors/tools';
import { setLoadingUnique } from '../../../../actions';
import NoSearchResults from './Common/NoSearchResults/NoSearchResults';
import { SearchResults } from './Common/SearchResults/SearchResults';
import { displayPopupMessageInformation } from 'components/tools/SearchPage/searchUtils';
import { lookupAndSetAccounts } from '../../../../actions/tools/DecisionTree/accountSearchActions';
import DTSearchView from '../../Common/DTSearchView/DTSearchView';

export const DTAccountSearchView = (props) => {
  const { onNextButtonClick, isNextButtonActive } = props;
  const dispatch = useDispatch();
  const accounts = useSelector(getAccounts);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const setLoading = useCallback((loading) => dispatch(setLoadingUnique(loading, 'searchPage')), [dispatch]);

  const handleSearchSubmit = useCallback(
    async (value) => {
      if (!value.trim()) {
        return displayPopupMessageInformation('Please enter a valid account id');
      }

      setLoading(true);
      await dispatch(lookupAndSetAccounts(value, simplrAccountId));
      setLoading(false);
    },
    [dispatch, setLoading, simplrAccountId]
  );

  return (
    <DTSearchView
      isNextButtonActive={isNextButtonActive}
      onNextButtonClick={onNextButtonClick}
      handleSearchSubmit={handleSearchSubmit}
      placeholder={'Search by account id'}
      searchType={'searchById'}
      defaultValue={''}
      dataToDisplay={accounts}
      searchResultsComponent={<SearchResults />}
      noDataMessageComponent={<NoSearchResults />}
    />
  );
};

export default DTAccountSearchView;
